<template>
  <v-container id="my-contacts" fluid tag="section">
    <v-overlay :value="isOverlayVisible">
      <v-progress-circular :size="70"
                           :width="7"
                           color="green"
                           indeterminate
                           class="spinner" />
    </v-overlay>
    <base-v-component heading="System Templates"
                      sub-heading="Manage System Templates" />

    <template>
      <v-toolbar flat color="transparent">
        <v-select v-model="selectedFilterCategoryId"
                  class="filterSelector"
                  :items="templateCategories"
                  label="Select Filter"
                  item-text="name"
                  item-value="TemplateCategoryID">
          </v-select>
        <v-spacer />
        <v-spacer />
        <v-spacer />
        <v-spacer />
        <v-btn color="primary" dark class="mb-2" @click="addNewTemplate">
          <v-icon small class="mr-2"> mdi-plus </v-icon>
          Add New System Template
        </v-btn>
        <template-add-edit-dialog :is-visible="isTemplateAddEditDialogVisible"
                                  :is-edit-mode="isTemplateEditMode"
                                  :selected-template="selectedTemplate"
                                  :templateCategories="templateCategories"
                                  :templatePlaceholders="templatePlaceholders"
                                  :allTemplates="allTemplates"
                                  @on-submit="templateModalActionStart"
                                  @on-close="hideTemplateModal"
                                  @on-success="templateModalActionSuccess"
                                  @on-error="templateModalActionError" />
      </v-toolbar>
    </template>

    <v-data-table :headers="headers"
                  :items="filteredTemplates"
                  item-key="cellNumber"
                  sort-by="firstName">
      <template v-slot:[`item.actions`]="{ item }">
        <div class="senderActions">
          <div class="commBtnWrapper">
            <v-tooltip v-if="item.templateTypeID === 2" left>
              <template v-slot:activator="{ on, attrs }">
                <button class="quick-comm-btn"
                        @click="_showBulkEmailComposer(item)"
                        v-bind="attrs"
                        v-on="on">
                  <v-icon>mdi-email-edit</v-icon>
                </button>
              </template>
              <span>Compose Email</span>
            </v-tooltip>
            <!-- <v-tooltip v-if="item.templateTypeID === 1" left>
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="quick-comm-btn"
                  @click="_showBulkMessageComposer(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-message-draw</v-icon>
                </button>
              </template>
              <span>Compose Message</span>
            </v-tooltip> -->
            <v-tooltip v-if="item.templateTypeID === 3" left>
              <template v-slot:activator="{ on, attrs }">
                <button class="quick-comm-btn"
                        @click="_showBulkIvrComposer(item)"
                        v-bind="attrs"
                        v-on="on">
                  <v-icon>mdi-phone</v-icon>
                </button>
              </template>
              <span>Compose IVR</span>
            </v-tooltip>
          </div>
          <v-btn v-if="!item.isSystemTemplate"
                 color="primary"
                 outlined
                 x-small
                 @click="editTemplate(item)">
            Edit
          </v-btn>
          &nbsp;

          <v-icon v-if="!item.isSystemTemplate" small @click="deleteTemplate(item)">
            mdi-delete
          </v-icon>
        </div>
      </template>
      <template v-slot:no-data>
        <p class="mb-4 mt-4">No templates to display</p>
        <v-btn color="primary" outlined class="mb-4" @click="_initiateLoad">
          Refresh
        </v-btn>
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <div class="py-3" />
  </v-container>
</template>

<script>
  /* eslint-disable */
  import { VueMaskDirective } from "v-mask";
  import Vue from "vue";
  import { ApiCalls } from "../../../../api-calls";
  import UserHelper from "../../../../utils/user-helper";
  import HelperMethods from "../../../../utils/helper-methods";
  import EventEmitter from "../../../../utils/event-emitter";

  Vue.directive("mask", VueMaskDirective);

  export default {
    components: {
      TemplateAddEditDialog: () => import(
        "../../components/system-template-add-edit-dialog/system-template-add-edit-dialog.vue"
      ),
    },
    data: () => ({
      dialog: false,
      headers: [
        { text: "Name", value: "Name" },
        // { text: "Body", value: "templateBody" },
        { text: "Description", value: "Description" },
        { text: "Category", value: "templateCategory" },
        { text: "Template Type", value: "templateType" },
        { text: "Actions", value: "actions" },
      ],
      snackbar: false,
      notification: "Unknown",
      isOverlayVisible: false,
      allTemplates: [],
      filteredTemplates: [],
      templateCategories: [],
      templateTypes: [],
      templatePlaceholders: [],
      selectedFilterCategoryId: -1,
      isTemplateAddEditDialogVisible: false,
      isTemplateEditMode: false,
      isAdmin: false,
      selectedTemplate: {}
    }),
    watch: {
      selectedFilterCategoryId() {
        this._loadFilteredTemplates();
      }
    },
    created() {
      this.isAdmin = UserHelper.hasAdminAccess();
      if (this.isAdmin) {
        this.headers.push({ text: "Actions", value: "actions", sortable: false });
      }
      this._initiateLoad();
    },
    methods: {
      _getTemplateTypeLabelFromId(typeId) {
        switch (typeId) {
          case 1: {
            return "SMS Template";
          }
          case 2: {
            return "Email Template";
          }
          case 3: {
            return "IVR Template";
          }
        }
      },
      async _loadFilteredTemplates() {
        try {
          this.isOverlayVisible = true;
          const { data } = await ApiCalls.fetchSystemTemplates(
            this.selectedFilterCategoryId
          );
          this.allTemplates = data;
          const idMappedTemplateCategories = [];
          this.templateCategories.forEach((c) => {
            idMappedTemplateCategories[c.TemplateCategoryID] = c.TemplateCategory;
          });
          this.templateCategories = this.templateCategories.map((category) => ({
            ...category,
            // eslint-disable-next-line no-nested-ternary
            name: (category.TemplateCategoryID === 1 ? 'SMS templates' : category.TemplateCategoryID === 2 ? 'Email templates' : '')
          }));

          this.templateCategories.map((x) => x.Name);

          this.templateCategories = this.templateCategories.filter(category => ['SMS templates', 'Email templates']);
          this.allTemplates = this.allTemplates.map((t) => ({
            ...t,
            templateType: this._getTemplateTypeLabelFromId(t.TemplateTypeID),
            templateCategory: idMappedTemplateCategories[t.TemplateCategoryID],
          }));
          this._filterTemplates();
        } catch (error) {
          console.log("error :>> ", error);
        }
        this.isOverlayVisible = false;
      },
      async _initiateLoad() {
        await HelperMethods.sleepTime(400);
        try {
          this.isOverlayVisible = true;
          const responses = await Promise.all([
            ApiCalls.fetchSystemTemplates(1),
            ApiCalls.fetchTemplateCategories(),
            ApiCalls.fetchTemplateTypes(),
            ApiCalls.fetchTemplatePlaceholders(),
          ]);
          const allTemplates =
            responses[0].data && responses[0].data.length
              ? responses[0].data
              : [];
          this.templateCategories = responses[1].data;
          this.templateCategories = this.templateCategories.map((category) => ({
            ...category,
            name: category.TemplateCategoryID === 1 ? 'SMS templates' : (category.TemplateCategoryID === 2 ? 'Email templates' : '')
          }));
          this.templateCategories = this.templateCategories.filter(category => ['SMS templates', 'Email templates']);
          const idMappedTemplateCategories = [];
          this.templateCategories.forEach((c) => {
            idMappedTemplateCategories[c.TemplateCategoryID] = c.TemplateCategory;
          });
          if (responses[1] && responses[1].data && responses[1].data.length) {
            this.selectedFilterCategoryId =
              responses[1].data[0].TemplateCategoryID;
          }
          this.templateTypes = responses[2].data;
          this.templatePlaceholders = responses[3].data;
          this.allTemplates = allTemplates.map((t) => ({
            ...t,
            templateType: this._getTemplateTypeLabelFromId(t.TemplateTypeID),
            templateCategory: idMappedTemplateCategories[t.TemplateCategoryID],
          }));
          this._filterTemplates();
        } catch (error) {
          console.log("error :>> ", error);
          this.allTemplates = [];
          this.snackbar = true;
        }
        this.isOverlayVisible = false;
      },
      _filterTemplates() {
        this.filteredTemplates = this.allTemplates;
      },
      addNewTemplate() {
        this.isTemplateEditMode = false;
        this.isTemplateAddEditDialogVisible = true;
      },
      templateModalActionStart() {
        this.isOverlayVisible = true;
      },
      async templateModalActionSuccess() {
        this.hideTemplateModal();
        await this._initiateLoad();
        this.isOverlayVisible = false;
      },
      hideTemplateModal() {
        this.isTemplateAddEditDialogVisible = false;
      },
      editTemplate(selectedTemplate) {
        this.selectedTemplate = selectedTemplate;
        this.isTemplateAddEditDialogVisible = true;
        this.isTemplateEditMode = true;
      },
      templateModalActionError(error) {
        this.isOverlayVisible = false;
        this.notification = "Server error";
        this.snackbar = true;
        throw error;
      },
      async deleteTemplate(template) {
        if (window.confirm(`Are you sure you want to delete ${template.Name}? `)) {
          this.isOverlayVisible = true;
          try {
            await ApiCalls.deleteTemplate(template.TemplateID).then(x => {
              this._initiateLoad();
              console.log(x);
              this.notification = "Deleted template";
              this.snackbar = true;
              this.$forceUpdate();
            });
          } catch (error) {
            this.notification = "Unable to delete";
            this.snackbar = true;
          }
          this.isOverlayVisible = false;
        }
      },
      _showBulkMessageComposer(template) {
        EventEmitter.dispatch("show-group-bulk-sms-composer", {
          selectedTemplate: {
            ...template,
            isSystemTemplate: true
          }
        });
      },
      _showBulkEmailComposer(template) {
        EventEmitter.dispatch("show-group-bulk-email-composer", {
          selectedTemplate: {
            ...template,
            isSystemTemplate: true
          }

        });
      },
      _showBulkIvrComposer(template) {
        EventEmitter.dispatch("show-group-bulk-ivr-composer", {
          selectedTemplate: {
            ...template,
            isSystemTemplate: true
          }
        });
      },
    },
  };
</script>
<style scoped lang="scss">
  .v-overlay.v-overlay--active.theme--dark {
    z-index: 300 !important;
  }

  .spinner {
    margin-left: 17rem;
  }

  @media only screen and (max-width: 968px) {
    .spinner {
      margin-left: 0;
    }
  }

  .senderActions {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .commBtnWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .quick-comm-btn {
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    margin-right: 15px;
    align-items: center;
    background-color: rgb(0, 114, 44);
    box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.12);
    color: white;
    font-size: 12px;

    * {
      font-size: 12px;
      color: white;
    }

    border-radius: 100px;
  }

  .senderActions {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .commBtnWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .quick-comm-btn {
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    margin-right: 15px;
    align-items: center;
    background-color: rgb(0, 114, 44);
    box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.12);
    color: white;
    font-size: 12px;

    * {
      font-size: 12px;
      color: white;
    }

    border-radius: 100px;
  }

  .systemTemplateTicker {
    background-color: chocolate;
    border-radius: 25px;
    padding: 2px 12px;
    font-size: 0.7rem;
    font-weight: 600;
    text-align: center;
    color: white;
  }

  .tickerWrapper {
    display: flex;

    button {
      font-size: 0.6rem;
      margin-left: 15px;
      cursor: pointer;
    }
  }
</style>
